/* EGIDOO email popup — native <dialog>, no dependencies. */
(function () {
  var el = document.querySelector('[data-eg-popup]');
  if (!el || typeof el.showModal !== 'function') return;

  var KEY_SUB = 'eg:popup:subscribed';
  var KEY_DIS = 'eg:popup:dismissed';
  var SNOOZE = 30 * 24 * 60 * 60 * 1000; // 30 days
  var lastFocus = null;
  var timer = null;
  var armed = true;

  function store(k, v) {
    try { localStorage.setItem(k, v); } catch (e) {}
  }
  function read(k) {
    try { return localStorage.getItem(k); } catch (e) { return null; }
  }

  function disarm() {
    armed = false;
    if (timer) clearTimeout(timer);
    document.removeEventListener('mouseleave', onExit);
  }

  function open() {
    if (el.open) return;
    disarm();
    lastFocus = document.activeElement;
    el.showModal();
    var focusTarget = el.querySelector('input[type="email"], .eg-pop__success');
    if (focusTarget) focusTarget.focus();
  }

  function dismiss() {
    store(KEY_DIS, String(Date.now()));
  }

  function restoreFocus() {
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function onExit(e) {
    if (e.clientY <= 0) open();
  }

  // Persist at the point of action rather than on the dialog's "close" event:
  // the event is fired from a queued task and is unreliable in a backgrounded
  // tab, which would lose the dismissal and re-show the popup on every page.
  el.addEventListener('click', function (e) {
    if (!e.target.closest('[data-eg-popup-close]')) return;
    dismiss();
    el.close();
    restoreFocus();
  });

  // Escape. "cancel" is the documented hook; the keydown guard covers the same
  // path if the event does not arrive.
  el.addEventListener('cancel', dismiss);
  el.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') dismiss();
  });
  el.addEventListener('close', restoreFocus);

  // 1. Returning from a successful submit: reopen in the success state.
  //    The hash check matters — form.posted_successfully? is true for ANY
  //    customer form on the page, including the inline signup section.
  if (el.dataset.posted === 'true' && window.location.hash === '#EgidooPopup') {
    store(KEY_SUB, '1');
    open();
    return;
  }

  // 2. Already subscribed, or dismissed recently.
  if (read(KEY_SUB)) return;
  var dismissed = parseInt(read(KEY_DIS) || '0', 10);
  if (dismissed && Date.now() - dismissed < SNOOZE) return;

  // 3. In the theme editor, let the merchant open it deliberately.
  if (el.dataset.designMode === 'true') {
    document.addEventListener('shopify:section:select', function (e) {
      if (el.closest('[id^="shopify-section"]') === e.target) open();
    });
    return;
  }

  // 4. Timer, and exit intent on pointer devices. First to fire wins.
  var delay = parseInt(el.dataset.delay || '8000', 10);
  timer = setTimeout(function () {
    if (armed && !document.querySelector('cart-drawer.active')) open();
  }, delay);

  if (el.dataset.exitIntent === 'true' && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseleave', onExit);
  }
})();
